import { render, staticRenderFns } from "./AllBatchesTable.vue?vue&type=template&id=40feecd8&scoped=true&"
import script from "./AllBatchesTable.vue?vue&type=script&lang=js&"
export * from "./AllBatchesTable.vue?vue&type=script&lang=js&"
import style0 from "./AllBatchesTable.vue?vue&type=style&index=0&id=40feecd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40feecd8",
  null
  
)

export default component.exports